import { useState, useEffect } from "react";
import Cookies from "universal-cookie";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { message } from "antd";
// import { UserOutlined, KeyOutlined } from "@ant-design/icons";
import { Route, Switch } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { getUserState } from "state/selector";
import colors from "constants/palette";
import { adminRoutes, userRoutes } from "routes";
import Sidebar from "components/dashboard/Sidebar";
import Header from "components/dashboard/Header";
import Loading from "components/App/Loading";
import Fetch from "components/Fetch";
import { updateUser, updateNotification } from "state/actions";

function imgPreloader() {
  this.images = [];

  this.addImages = function (images) {
    var self = this;

    if (!images) return;

    if (Array.isArray(images)) {
      images.forEach(function (ele) {
        var _image = new Image();
        _image.src = ele;
        self.images.push(_image);
      });
    }
  };

  return this;
}

/* To use, simply pass in an array of  images */
var newImage = new imgPreloader();
newImage.addImages([
  `${process.env.REACT_APP_URL}/images/background-1.jpg`,
  `${process.env.REACT_APP_URL}/images/background-2.jpg`,
  `${process.env.REACT_APP_URL}/images/background-3.jpg`,
  `${process.env.REACT_APP_URL}/images/background-4.jpg`,
  `${process.env.REACT_APP_URL}/images/background-5.jpg`,
  `${process.env.REACT_APP_URL}/images/background-6.jpg`,
  `${process.env.REACT_APP_URL}/images/background-7.jpg`,
  `${process.env.REACT_APP_URL}/images/background-8.jpg`,
]);

export default function DashboardIndex() {
  const history = useHistory();
  const cookies = new Cookies();
  const dispatch = useDispatch();
  const token = cookies.get("__token");
  const user = useSelector(getUserState);
  const [loading, setLoading] = useState(true);
  const [reload] = useState(false);

  function check(isFirst) {
    if (!token) {
      history.push("/auth/login");
    } else {
      Fetch.check(token, (res) => {
        if (res) {
          setLoading(false);
          if (!user?.id && isFirst) {
            dispatch(updateUser(res.data.user));
          }
          res.data.user?.notifications &&
            dispatch(
              updateNotification({
                data: JSON.parse(res.data.user.notifications),
              })
            );
          // dispatch(updateUser(res.data.user));

          return res;
        } else {
          // console.log(cookies.get("__token"));
          // console.log("check dashboard", res);
          history.push("/auth/login");
          message.error("ورود نامعتبر - دوباره تلاش کنید");
        }
      });
    }
  }
  // eslint-disable-next-line
  useEffect(() => {
    check(true);
    let interval = setInterval(() => {
      check();
      console.log("check");
    }, 30000);

    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line
  }, []);

  const UserSwitch = () => (
    <Switch>
      {/* protectedRoutes */}
      {userRoutes.map((e, key) => (
        <Route path={e.link} component={e.component} key={key} />
      ))}
    </Switch>
  );
  const AdminSwitch = () => (
    <Switch>
      {/* protectedRoutes */}
      {adminRoutes.map((e, key) => (
        <Route path={e.link} component={e.component} key={key} />
      ))}
    </Switch>
  );
  console.log("dashboard index USER", user);

  const role = Number(user.role);
  return (
    <Container>
      <Overlay hide={!loading || !reload || !user}>
        <Loading
          style={{ height: 100 }}
          spinnerStyle={{
            background: "#3A4041",
            boxShadow: `0 0px 5px 0px #3A4041`,
          }}
        />
        در حال برقراری ارتباط
      </Overlay>
      {!loading && user.id && (
        <>
          <Sidebar />
          <Content type={role}>
            <Header />
            <Main>
              <AdminSwitch />
            </Main>
          </Content>
        </>
      )}
      <BGImage />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  height: 100vh;
  width: 100vw;
  position: relative;
`;

const BGImage = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  ${colors.bgImage
    ? `

  background: ${`url(${process.env.REACT_APP_URL}/images/background-${colors.bgImage}.jpg)`};
  /* Add the blur effect */
  filter: blur(2px);

  /* Full height */
  height: 100%;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  `
    : `background: ${colors.white}`}
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  width: ${({ type }) => (type === 1 ? "calc(100% - 264px)" : "100%")};
  margin: 0 4%;
  overflow-x: auto;

  @media (max-width: 1080px) {
    width: 100%;
  }
`;
const Main = styled.main`
  height: calc(100vh - 128px);
  padding: 28px 10px;
  overflow: auto;
  @media (max-width: 480px) {
    padding: 5px 10px;
  }
`;
const Overlay = styled.div`
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9999;
  backdrop-filter: blur(2px);
  animation: ${({ hide }) =>
    hide && "fadeOut .2s cubic-bezier(0.85, 0.08, 0.18, 0.36) forwards"};
  animation-delay: 2.4s;
  opacity: 1;
  background: #3a4041;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  align-items: center;
  color: white;
  @keyframes fadeOut {
    0% {
      opacity: 1;
    }
    80% {
      opacity: 0;
    }
    100% {
      opacity: 0;
      display: none;
      z-index: -9999;
    }
  }
`;
